import { useIsOgpPlannerOrHigher } from 'ogp/hooks';
import { useState } from 'react';
import { useFeatureFlagContext } from 'shared/contexts/feature-flag-provider';
import { UseWorkFormCreationTabsParams } from './use-work-form-creation-tabs.types';
import { WorkFormCreationType } from '../work-form-creation-type.types';

export const useWorkFormCreationTabs = ({ formMode, isOGP }: UseWorkFormCreationTabsParams) => {
  const { allowMultiDayWorkCreation } = useFeatureFlagContext();
  const isOgpPlannerOrHigher = useIsOgpPlannerOrHigher();
  const [creationType, setCreationType] = useState<WorkFormCreationType>('single');

  const showCreationTabs =
    formMode === 'create' && isOGP && allowMultiDayWorkCreation && isOgpPlannerOrHigher;

  const isMultiDayCreation = showCreationTabs && creationType === 'multi-day';

  return {
    showCreationTabs,
    creationType,
    setCreationType,
    isMultiDayCreation,
  };
};
